export default __webpack_public_path__ + "static/media/beauty-icon.d61a2c25.svg";